export const AnalyticsConfiguration = {
  universalTrackingId: process.env.REACT_APP_GoogleAnalyticsTrackingId || "",
};
